import React, { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";

import { OrderDetails } from "../../../stores/slices/cartSlice";
import { CustomPart } from "../../../stores/slices/packageEditorSlice";
import { Button } from "../../../ui/Button/Button";
import { TabPanels, TabPanelsContext } from "../../../ui/TabPanels/TabPanels";
import { OrderItemList } from "../../Cart/CartPreview/OrderItemList";
import { CustomPartForm } from "../CustomParts/CustomPartForm";
import { CustomParts } from "../CustomParts/CustomPartList";

export const PartList: FunctionComponent<{
  addCustomPart(customPart: CustomPart): void;
  customParts: CustomPart[];
  orderDetails: OrderDetails;
  partListTabIndex: number;
  removeCustomPart(customPartNumber: string): void;
  setPartListTabIndex(index: number): void;
  updateCustomPart(customPart: CustomPart): void;
}> = ({
  addCustomPart,
  customParts,
  orderDetails,
  partListTabIndex,
  removeCustomPart,
  setPartListTabIndex,
  updateCustomPart,
}) => {
  const { t } = useTranslation();
  const tabsContextRef = useRef<TabPanelsContext>();

  return (
    <TabPanels contextRef={tabsContextRef} defaultIndex={partListTabIndex}>
      <div className="p-4 space-y-6">
        <OrderItemList cart={orderDetails} />
        <CustomParts
          customParts={customParts}
          removeCustomPart={removeCustomPart}
          updateCustomPart={updateCustomPart}
        />
        <hr />
        <Button
          onClick={(): void => {
            setPartListTabIndex(1);
            tabsContextRef.current?.setIndex(1);
          }}
          aria-label="addCustomPart"
          className="mx-auto flex"
        >
          {t("packageEditor.addCustomPart")}
        </Button>
      </div>
      <CustomPartForm
        handleReset={(): void => {
          setPartListTabIndex(0);
          tabsContextRef.current?.setIndex(0);
        }}
        handleSubmit={addCustomPart}
      />
    </TabPanels>
  );
};
